<p-toast position="top-center" />
@let closePt = dialogPt('COMMON.CLOSE' | translate);
<p-confirmdialog key="unsavedChanges" [pt]="closePt" styleClass="wn-unsaved-confirm" />
<p-confirmdialog key="deleteConfirm" [pt]="closePt" styleClass="wn-delete-confirm" />
<p-confirmdialog key="actionConfirm" [pt]="closePt" styleClass="wn-action-confirm" />
<router-outlet />
